const globalVariables = {
  footerHeight: 1100,
  linkColorWindowOffsetY: 65,
  remainingArticlesHeight: 655,
  recentAssessmentsHeight: 730,
};

export default globalVariables;
